export const firstAidGuides = [
  {
    id: "fa-bleeding",
    title: "Severe bleeding",
    icon: "ri-drop-fill",
    summary: "Control blood loss fast with firm, steady pressure.",
    steps: [
      "Wash your hands or wear gloves if you have them, then press a clean cloth or gauze firmly onto the wound.",
      "Keep continuous pressure for at least 5-10 minutes without lifting the cloth to check.",
      "If blood soaks through, add more cloth on top. Do not remove the first layer.",
      "Once the bleeding slows, bandage the wound firmly and keep the injured part raised if you can.",
      "Call 108 if bleeding is heavy, spurting, or has not stopped after 10 minutes of pressure.",
    ],
    avoid: [
      "Do not use a tourniquet unless you are trained and the bleeding is life-threatening.",
      "Do not pull out an object that is stuck deep in the wound - press around it instead.",
    ],
  },
  {
    id: "fa-burns",
    title: "Burns",
    icon: "ri-fire-fill",
    summary: "Cool the burn with running water and keep it clean.",
    steps: [
      "Move the person away from the heat source and make sure the area is safe.",
      "Cool the burn under cool - not ice-cold - running water for a full 20 minutes.",
      "Remove rings, watches or tight clothing near the burn before it starts to swell.",
      "Cover the burn loosely with cling film or a clean, non-fluffy cloth.",
      "Call 112 for large or deep burns, burns to the face or hands, or if the person feels faint.",
    ],
    avoid: [
      "Do not apply ice, butter, toothpaste or oil to a burn.",
      "Do not burst any blisters that form.",
    ],
  },
  {
    id: "fa-cpr",
    title: "CPR (adult)",
    icon: "ri-heart-pulse-fill",
    summary: "Push hard and fast in the centre of the chest until help arrives.",
    steps: [
      "Check that the person is unresponsive and not breathing normally, then shout for help.",
      "Call 112 and ask someone to bring an AED (defibrillator) if one is nearby.",
      "Place the heel of one hand in the centre of the chest, put your other hand on top and interlock your fingers.",
      "Push down 5-6 cm at 100-120 compressions per minute, letting the chest rise fully each time.",
      "Keep going until the person responds, an AED is ready, or emergency responders take over.",
    ],
    avoid: [
      "Do not stop repeatedly to check for a pulse - keep interruptions to a minimum.",
      "Do not be afraid to push hard - effective compressions save lives.",
    ],
  },
  {
    id: "fa-choking",
    title: "Choking",
    icon: "ri-emotion-unhappy-fill",
    summary: "Encourage coughing, then use back blows and abdominal thrusts.",
    steps: [
      "If the person can cough or speak, encourage them to keep coughing hard.",
      "If they cannot breathe, give 5 sharp back blows between the shoulder blades.",
      "If that fails, give 5 abdominal thrusts just above the navel.",
      "Alternate 5 back blows and 5 abdominal thrusts until the object clears.",
      "Call 112 if the blockage does not clear or the person becomes unresponsive.",
    ],
    avoid: [
      "Do not give abdominal thrusts to infants - use back blows and chest thrusts instead.",
      "Do not put your fingers blindly into the mouth to fish out the object.",
    ],
  },
];